<p>
  책장 삭제 시, 책장 및 책장 내 책 목록은
  <b>복구할 수 없습니다.</b> 삭제하시겠습니까?
</p>
<div class="actions">
  <button sui-solid-button varSize="large" (click)="_onClickDelete()">
    삭제하기
  </button>
</div>
